import { cloudinaryInstance } from "./Cloudinary/cloudinaryInstance";

export function resolveThemeImageUrl(urlOrKey) {
  if (!urlOrKey || typeof urlOrKey !== "string") return null;
  const trimmed = urlOrKey.trim();
  if (!trimmed) return null;
  if (trimmed.startsWith("http://") || trimmed.startsWith("https://") || trimmed.startsWith("/")) {
    return trimmed;
  }
  return cloudinaryInstance.image(trimmed).format("webp").toURL();
}
